var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"highlight value"},[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))]),_c('my-divider',{attrs:{"height":"10px"}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }